import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject, firstValueFrom } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { Hole } from '../models/hole.model';
import { User } from '../models/user.model';

@Injectable({
  providedIn: 'root'
})
export class UsersService {
  userChanged = new Subject<User>();
  constructor(private http: HttpClient) { }

  getCurrent(): Observable<User> {
    return this.http.get<User>(environment.apiUrl + `/user`).pipe(
      tap((data: User) => this.userChanged.next(data)),
      catchError(err => { throw err; })
    );
  }

  saveCurrent(user: User): Observable<User> {
    return this.http.put<User>(environment.apiUrl + `/user`, user).pipe(
      tap((data: User) => this.userChanged.next(data)),
      catchError(err => { throw err; })
    );
  }

  async subscriptionValid(): Promise<boolean> {
    const user = await firstValueFrom(this.getCurrent());
    return ['active', 'trialing', 'grace_period'].includes(user.subscriptionStatus ?? '');
  }

  async getCheckoutSession(tier: 'pro' | 'club'): Promise<any> {
    const response = await firstValueFrom(this.http.get<any>(environment.apiUrl + `/checkout-session?tier=${tier}`));
    return response;
  }

  async getCheckoutRedirectUrl(tier: 'pro' | 'club', courseId?: number): Promise<string> {
    let params = `?tier=${tier}`;
    if (courseId != null) { params += `&courseId=${courseId}`; }
    const response = await firstValueFrom(this.http.get<{ url: string }>(environment.apiUrl + `/checkout-session${params}`));
    return response.url;
  }

  async getCheckoutSessionStatus(sessionId: string): Promise<any> {
    const response = await firstValueFrom(this.http.get<any>(environment.apiUrl + `/checkout-status?session_id=${sessionId}`));
    return response;
  }
}
